module.exports = __webpack_public_path__ + "img/trash.de6c7891.svg";